module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty6.df0e6d67.jpg";